//dependencies
import $ from "jquery";

export default function() {

    function initScript() {

        $("body").on("click", "a[id^=factFeedBtn]", function(e){
            e.preventDefault();
            // Get the parent of this button.
            var parentContainer = $(this).closest("div[id^=factFeed]");
            var pageId = $(this).data("page");
            getCuriouslyCurryFact($(parentContainer), pageId);
        });

    }

    function getCuriouslyCurryFact(element, pageId)
    {
        $.ajax({
            url: window.curry.factFeed,
            type: "GET",
            data: {
                FactId: pageId
            },
            cache: false,
            success: function (response) {
                element.html(response);
            },
            error: function (xhr) {
                //Do Something to handle error
                alert("An error has occurred. Please contact an andministrator.");
            }
        });
    }

    initScript();
}


// WEBPACK FOOTER //
// ./src/ui/js/apps/articlefeed.js